export default __webpack_public_path__ + "static/hyundai tucson-48c247939c751e0d0d6c7c8ce5491822.png";